<template>
    <div class="MainSidebar">
        <div class="meun-title">
            <span>{{ subItem.menuName }}</span>
        </div>
        <div class="meun-list">
            <div class="meun-item" v-for="(item,index) in subItem.children" :key="index" @click="onTab(item.menuLink)" :class="{'active': onRoutes === item.menuLink}">
                <!--            <i :class="item.menuIcon"></i>-->
                <span>{{ item.menuName }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import bus from '@/components/common/bus';

export default {
    data(){
        return{
            subItem: [],
        }
    },
    created() {
        bus.$on('ChildMenu',(item)=>{
            this.subItem = item;
        })
    },
    computed: {
        onRoutes() {
            return this.$route.path;
        }
    },
    methods:{
        onTab(menuLink){
            if(this.onRoutes === menuLink){
                return
            }
            this.$router.push(menuLink);
        },
    }
}
</script>

<style scoped>
.MainSidebar{
    position: absolute;
    width: 160px;
    height: 100%;
    left: 100px;
    font-size: 14px;
    border-right: #e4eaec 1px solid;
}
.MainSidebar .active{
    background-color: #ecf5ff;
}
.meun-title{
    width: 159px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: #e4eaec 1px solid;
    background-color: #ffffff;
    font-size: 16px;
}
.meun-list{
    height: calc(100% - 50px);
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
}
.meun-item{
    width: 160px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.meun-item:hover{
    background-color: #ecf5ff;
}
.meun-item i{
    margin-right: 10px;
}

</style>